<button mat-button
    #tooltip="matTooltip" 
    [matTooltipPosition]="'below'"
    matTooltip="{{_tooltip}}"
    matTooltipPosition="right" 
    title="Show tooltip">
    <mat-icon>help</mat-icon>
</button>